"use client";
import styled from "@emotion/styled";
import { Typography, TypographyProps } from "@mui/material";
import { JSX } from "react";

export type TitleGradientTextProps = {
  children: JSX.Element | string;
} & TypographyProps;

const StyledText = styled(Typography)`
  background: linear-gradient(90deg, #cd7858 0%, #ffd969 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export function TitleGradientText(props: TitleGradientTextProps) {
  const { children, ...other } = props;
  return <StyledText {...other}>{children}</StyledText>;
}
